import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { store, persiststore } from "./store/store";
import reportWebVitals from "./reportWebVitals";
import { PersistGate } from "redux-persist/integration/react";
import { HelmetProvider } from "react-helmet-async";
import ErrorBoundary from "./shared-components/ErrorBoundary";
import { installDomGuard } from "./utils/domGuard";
import { captureAttribution } from "./utils/attribution";

installDomGuard();

const root = ReactDOM.createRoot(document.getElementById("root"));
window.Beacon("init", "f5b97d10-4d6c-42dd-84cf-0c4a8b143490");

// Must run before routing strips the query string off the entry URL.
captureAttribution();

root.render(
  // <React.StrictMode>
  <HelmetProvider>
    <BrowserRouter>
      <Provider store={store}>
        <PersistGate loading={null} persistor={persiststore} />
        <ErrorBoundary>
          <App />
        </ErrorBoundary>
      </Provider>
    </BrowserRouter>
  </HelmetProvider>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
